import React from 'react';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';
import { DurationSelector } from './DurationSelector';
import type { DateRange } from './DurationSelector/types';

interface CompareToControlProps {
  /** Whether a comparison ("vs") period is active. */
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  /** The comparison period; only shown/edited when enabled. */
  range: DateRange;
  onRangeChange: (range: DateRange) => void;
}

/**
 * "Compare to..." toggle plus a "vs" comparison-period picker. Shared by the
 * Wellness Overview filter bar and the Reporting generate wizard so the two
 * stay in lockstep. The parent owns the range/enabled state (Wellness Overview
 * persists it, the wizard keeps it ephemeral); this component only centralises
 * the markup and the "picking a complete range implicitly enables comparison"
 * rule so that logic is not copied per caller.
 */
export const CompareToControl: React.FC<CompareToControlProps> = ({
  enabled,
  onEnabledChange,
  range,
  onRangeChange,
}) => (
  <>
    <ToggleButtonGroup
      value={enabled ? 'on' : null}
      exclusive
      size='small'
      onChange={(_event, value) => onEnabledChange(value === 'on')}
    >
      <ToggleButton value='on'>Compare to...</ToggleButton>
    </ToggleButtonGroup>
    {enabled && (
      <DurationSelector
        value={range}
        buttonVariant='outlined'
        buttonLabel='vs'
        onChange={(next) => {
          onRangeChange(next);
          if (next[0] && next[1]) onEnabledChange(true);
        }}
      />
    )}
  </>
);
